import {DateTime} from 'luxon/src/datetime';

export interface StartAndEndDates {
  startDate?: DateTime;
  endDate?: DateTime;
}

export interface StartAndEndDatesWithPeriod extends StartAndEndDates {
  period?: DateRangePeriodsEnum;
}

export enum DateRangePeriodsEnum {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_WEEK_TO_DATE = 'this_week_to_date',
  LAST_SEVEN_DAYS = 'last_seven_days',
  LAST_WEEK = 'last_week',
  LAST_MONTH = 'last_month',
  LAST_QUARTER = 'last_quarter',
  LAST_YEAR = 'last_year',
  THIS_YEAR_TO_DATE = 'this_year_to_date',
}
